/* ──────────────────────────────────────────────────────────────────────
   Triple Y · פתיחה וסגירה של בועית «מצב המכשיר». 21.09.2026

   לחיצה על הסימן פותחת. לחיצה חוזרת, לחיצה מחוץ לבועית, או Escape —
   סוגרות. אותו דפוס בדיוק כמו ההסבר על קובייה שאזלה באילת.

   🔴 מאזין אחד על document, ולא מאזין לכל כפתור.
      `product-info.js` מרנדר מחדש את שורות האייקונים בכל החלפת ווריאנט,
      וכל מאזין שנרשם על אלמנט בתוכן מת באותו רגע. מתועד בחוקה.

   🔴 `hidden` ולא `display` בסגנון: כך מצב הפתיחה קריא מה-DOM, והבדיקה
      מודדת מצב ולא מראה.
   ────────────────────────────────────────────────────────────────────── */
(() => {
  'use strict';
  if (window.__tyCondHelpInit) return;
  window.__tyCondHelpInit = true;

  const OPEN_ATTR = 'aria-expanded';
  /* 🔴 אותו שם דגל בדיוק כמו ב-`ty-condition-auto.js`. שם הוא נכתב במעבר
     מ«חדש» ל-«Active New», וכאן הוא נמחק כשהלקוח סוגר. בלי המחיקה הבועית
     הייתה נפתחת מחדש בכל רינדור, עד שחלון הזמן נגמר. */
  const NOTICE_KEY = 'tyCondNotice';

  /** סגירה **ביוזמת הלקוח**: מורידה גם את שורת «שים לב» ואת הדגל. */
  function dismiss() {
    closeAll();
    document.querySelectorAll('.ty-condhelp__notice').forEach((n) => { n.hidden = true; });
    try { sessionStorage.removeItem(NOTICE_KEY); } catch (e) { /* מצב פרטי */ }
  }

  function closeAll(except) {
    document.querySelectorAll('[data-ty-condhelp]').forEach((w) => {
      if (w === except) return;
      const btn = w.querySelector('.ty-condhelp__btn');
      const bub = w.querySelector('.ty-condhelp__bubble');
      if (!btn || !bub) return;
      btn.setAttribute(OPEN_ATTR, 'false');
      bub.hidden = true;
    });
  }

  /** פותח בועית מסוימת. משמש גם את ההודעה האוטומטית במעבר בין מצבים. */
  function open(wrap) {
    const btn = wrap.querySelector('.ty-condhelp__btn');
    const bub = wrap.querySelector('.ty-condhelp__bubble');
    if (!btn || !bub) return;
    closeAll(wrap);
    btn.setAttribute(OPEN_ATTR, 'true');
    bub.hidden = false;
  }
  window.tyCondHelpOpen = open;
  /* ty-cond-notice-auto >>> */
  /* 02.10.2026, בקשת יובל: ההודעה במעבר («שים לב») נפתחת מהמשפט שמעל הסניפים והמחיר (.ty-aln),
     ולא משורת האייקונים, ונסגרת לבד אחרי שנייה. בלי משפט (ההגדרה ריקה) נופלים לשורת האייקונים.
     🔴 הסגירה האוטומטית מוחקת גם את הדגל (dismiss), אחרת הרינדור הבא היה פותח אותה שוב.
     🔴 ההשהיה לפני החיפוש: המשפט מתחלף לפי הווריאנט רק אחרי הרינדור, ובלעדיה הוא עוד מוסתר. */
  const TY_AUTO_MS = 1000;
  let tyAutoTimer = null;
  function showNotice(scope) {
    const root = scope || document;
    setTimeout(() => {
      const aln = Array.from(root.querySelectorAll('.ty-aln')).find((a) => !a.hidden && a.querySelector('[data-ty-condhelp]'));
      const wrap = (aln && aln.querySelector('[data-ty-condhelp]')) || root.querySelector('[data-ty-iwt] [data-ty-condhelp]') || root.querySelector('[data-ty-condhelp]');
      if (!wrap) return;
      const bub = wrap.querySelector('.ty-condhelp__bubble');
      if (tyAutoTimer && bub && !bub.hidden) return;
      const n = wrap.querySelector('.ty-condhelp__notice');
      if (n) n.hidden = false;
      open(wrap);
      /* רינדור באמצע השנייה פותח שוב, אבל אינו מאריך את השעון */
      if (!tyAutoTimer) tyAutoTimer = setTimeout(() => { tyAutoTimer = null; dismiss(); }, TY_AUTO_MS);
    }, 250);
  }
  window.tyCondNoticeShow = showNotice;
  /* לחיצה של הלקוח מבטלת את הסגירה האוטומטית, כדי שלא תסגור בועית שהוא פתח בעצמו */
  document.addEventListener('click', () => { clearTimeout(tyAutoTimer); tyAutoTimer = null; }, true);
  /* <<< ty-cond-notice-auto */

  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('.ty-condhelp__btn');
    if (btn) {
      e.preventDefault();
      const wrap = btn.closest('[data-ty-condhelp]');
      const isOpen = btn.getAttribute(OPEN_ATTR) === 'true';
      if (isOpen) { dismiss(); return; }
      /* 🔴 פתיחה ידנית היא בקשה להסבר, ולא התראה על מעבר. */
      const n = wrap.querySelector('.ty-condhelp__notice');
      if (n) n.hidden = true;
      open(wrap);
      return;
    }
    if (e.target.closest && e.target.closest('.ty-condhelp__close')) { dismiss(); return; }
    /* לחיצה בתוך הבועית עצמה אינה סוגרת, כדי שאפשר יהיה לסמן טקסט. */
    if (e.target.closest && e.target.closest('.ty-condhelp__bubble')) return;
    dismiss();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') dismiss();
  });
})();
